export const currentAndUpcoming = 'CURRENT_AND_UPCOMING';
export const past = 'PAST';
export const current = 'CURRENT';
export const upcoming = 'UPCOMING';

export const highlightActuals = 'ACTUAL_SESSIONS';
export const highlightAnnualised = 'ANNUALIZED';
export const highlightFullYear = 'FULL_YEAR';
export const highlightTermTime = 'TERM_TIME';
export const highlightCustom = 'CUSTOM';
export const highlightWarnings = 'WARNING';
export const TOOLBAR_FORM = 'MANAGE_PLANS_TOOLBAR_FORM';
